import React from 'react';

/**
 * Legacy, please use a Spinner to indicate loading state instead.
 */
function LegacyCircularThrobber(): JSX.Element {
  return <div className="spinner" />;
}

export default LegacyCircularThrobber;
